// extracted by mini-css-extract-plugin
export var brand = "_ay-9";
export var compact = "_ay-6";
export var extraSmall = "_ay-7";
export var icon = "_ay-0";
export var large = "_ay-4";
export var light = "_ay-1";
export var medium = "_ay-5";
export var outline = "_ay-b";
export var primaryDark = "_ay-a";
export var primaryLight = "_ay-8";
export var primaryModern = "_ay-c";
export var success = "_ay-2";
export var successSolid = "_ay-3";